import {sortBy, toLower} from 'ramda';

import i18n from '@dms/i18n';

export type AssignmentOption = {value: string; label: string};
type AssignmentOptionGroup = {label: string; options: AssignmentOption[]};

export const buildAssignedToOptions = (
  userOptions: AssignmentOption[],
  teamOptions: AssignmentOption[]
): AssignmentOption[] | AssignmentOptionGroup[] => {
  if (teamOptions.length === 0) {
    return userOptions;
  }

  return [
    {
      label: i18n.t('general.labels.participation.teamGroup'),
      options: sortBy((option) => toLower(option.label), teamOptions),
    },
    {
      label: i18n.t('general.labels.participation.userGroup'),
      options: sortBy((option) => toLower(option.label), userOptions),
    },
  ];
};
